import Typography from '@bexs/dollar/components/Typography';
import React from 'react';
import { DescriptionSubtitle } from 'components/CustomTitleAndSubtitle/styles';

const CustomTitleAndSubtitle = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => (
  <>
    <Typography as="p" plain>
      {title}
    </Typography>
    <DescriptionSubtitle as="small">{subtitle}</DescriptionSubtitle>
  </>
);

export default CustomTitleAndSubtitle;
